import {useLayoutState} from "../../store/layout.js";
import {LoadingOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {Button, Popconfirm, Space, Tooltip, Typography} from "../../../__snowpack__/pkg/antd.js";
import {isString} from "../../../__snowpack__/pkg/lodash.js";
import React, {cloneElement, useContext, useState} from "../../../__snowpack__/pkg/react.js";
import TableRowActionsContext from "./TableRowActionsContext.js";
const ActionButton = (props) => {
  const {text, permissionKey, visible = true, confirm, tooltip, children, disabled, onClick, ...restProps} = props;
  const [loading, setLoading] = useState(false);
  const {withPermissionClick} = useLayoutState();
  const context = useContext(TableRowActionsContext);
  const permissionKeys = Array.isArray(permissionKey) ? permissionKey : permissionKey ? [permissionKey] : [];
  if (!visible || permissionKey && permissionKeys.find((_permissionKey) => !withPermissionClick(_permissionKey))) {
    return null;
  }
  const _onClick = (e) => {
    const result = onClick?.(e);
    if (result instanceof Promise) {
      setLoading(true);
      result.finally(() => {
        setLoading(false);
      });
    }
  };
  let actionButton = /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    size: "small",
    ...restProps,
    onClick: (e) => {
      if (!confirm) {
        _onClick(e);
      }
    },
    disabled: disabled || loading
  }, /* @__PURE__ */ React.createElement("span", {
    style: {position: "relative"}
  }, text ?? children, loading && /* @__PURE__ */ React.createElement(LoadingOutlined, {
    style: {position: "absolute", left: "50%", top: "50%", marginLeft: -6, marginTop: -6, color: "#6020FF"}
  })));
  if (tooltip) {
    const defaultTooltipProps = {
      trigger: ["hover", "click"],
      overlayStyle: {
        pointerEvents: "none"
      }
    };
    const tooltipProps = isString(tooltip) ? {title: tooltip} : tooltip;
    if (actionButton.props.icon && (!children || Array.isArray(children) && children?.length === 0)) {
      actionButton = cloneElement(actionButton, {
        icon: /* @__PURE__ */ React.createElement(Tooltip, {
          ...defaultTooltipProps,
          ...tooltipProps
        }, actionButton.props.icon)
      });
    } else {
      actionButton = /* @__PURE__ */ React.createElement(Tooltip, {
        ...defaultTooltipProps,
        ...tooltipProps
      }, actionButton);
    }
  }
  if (confirm) {
    return /* @__PURE__ */ React.createElement(Popconfirm, {
      placement: "topRight",
      align: {targetOffset: [0, -5]},
      arrowPointAtCenter: true,
      ...confirm,
      overlayStyle: {minWidth: 180, maxWidth: 400, ...confirm?.overlayStyle},
      onConfirm: (e) => {
        _onClick(e);
      },
      onVisibleChange: (visible2) => {
        context.setKeepMoreButtonPopoverOpen(visible2);
      },
      disabled: disabled || confirm.disabled,
      title: /* @__PURE__ */ React.createElement(Space, {
        direction: "vertical"
      }, /* @__PURE__ */ React.createElement(Typography.Text, null, confirm.title), /* @__PURE__ */ React.createElement(Typography.Text, {
        type: "secondary"
      }, confirm.content))
    }, actionButton);
  }
  return actionButton;
};
export default ActionButton;
